import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { WelcomeInvitationConfig } from "@/models/welcomeInvitationConfig"

export interface CreateInvitationConfigArgs {
  title?: string
  invitationMessage?: string
  rsvpEnabled?: boolean
  rsvpEmailEnabled?: boolean
  allowSongRequests?: boolean
  allowDietaryRequirements?: boolean
  allowPublicGuestList?: boolean
}

export interface ICreateInvitationConfigArgsParams {
  eventAlbumId?: number
}

export async function createInvitationConfig(invitationConfig: CreateInvitationConfigArgs, eventVaultId: number, albumId?: number) {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to create invitation config. Please ensure `eventVaultId` is provided.")
  }

  const options: AxiosRequestConfig = {}

  const params: ICreateInvitationConfigArgsParams = {
    eventAlbumId: albumId,
  }

  if (params.eventAlbumId) {
    options.params = params
  }

  const response = await v1.post(`/events/${eventVaultId}/invitation`, invitationConfig, options)

  return WelcomeInvitationConfig.fromResponse(response.data.data)
}

const CREATE_INVITATION_CONFIG = "createInvitationConfig"

export function useCreateInvitationConfig(eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [CREATE_INVITATION_CONFIG, eventVaultId, albumId],
    mutationFn: (invitationConfig: CreateInvitationConfigArgs) => createInvitationConfig(invitationConfig, toValue(eventVaultId)!, toValue(albumId)),
  })
}
